module.exports = __webpack_public_path__ + "media/images/riders/small/RACHEL_ATHERTON-74e5455d1712e75ad51e432e0218ceb8.png";